export default {
    CHANGE_CAMERA_ROLE: function(state, cameraOn) {
        let roomSetting = this.getters['roomSetting/roomSetting']
        roomSetting['defaultRoleCamera'] = cameraOn
    },
    CHANGE_MIC_ROLE: function(state, micOn) {
        let roomSetting = this.getters['roomSetting/roomSetting']
        roomSetting['defaultRoleMic'] = micOn
    },
    CHANGE_RESET_ROLE: function(state, reset) {
        let roomSetting = this.getters['roomSetting/roomSetting']
        roomSetting['defaultRoleReset'] = reset
    },
    CHANGE_DEFAULT_ROLEID: function(state, defaultRoleId) {
        let roomSetting = this.getters['roomSetting/roomSetting']
        roomSetting['defaultRoleId'] = defaultRoleId
    },
    CHANGE_DEFAULT_DEVICE: function(state, defaultDevice) {
        let roomSetting = this.getters['roomSetting/roomSetting']
        roomSetting['defaultDeviceType'] = defaultDevice
    },
    CHANGE_CHAT_MODE: function(state, chatMode) {
        let roomSetting = this.getters['roomSetting/roomSetting']
        roomSetting['useChat'] = chatMode
    },
    CHANGE_WAITING_MODE: function(state, waitingMode) {
        let roomSetting = this.getters['roomSetting/roomSetting']
        roomSetting['useWaitingMode'] = waitingMode
    },
    CHANGE_DEVICE_REQUIRED: function(state, deviceRequired) {
        let roomSetting = this.getters['roomSetting/roomSetting']
        roomSetting['isDeviceRequired'] = deviceRequired
    },
    CHANGE_TRANSLATE_MODE: function(state, translateMode) {
        let roomSetting = this.getters['roomSetting/roomSetting']
        roomSetting['useTranslate'] = translateMode
    },
    CHANGE_STICKER_MODE: function(state, stickerMode) {
        let roomSetting = this.getters['roomSetting/roomSetting']
        roomSetting['useSticker'] = stickerMode
    },
    CHANGE_DOC_MARGIN: function(state, docMargin) {
        let roomSetting = this.getters['roomSetting/roomSetting']
        roomSetting['useDocMargin'] = docMargin
    },
    CHANGE_USE_QNA: function(state, useQnA) {
        let roomSetting = this.getters['roomSetting/roomSetting']
        roomSetting['useQnA'] = useQnA
    },
    CHANGE_USE_QNA_SHARE: function(state, useQnAShare) {
        let roomSetting = this.getters['roomSetting/roomSetting']
        roomSetting['useQnAShare'] = useQnAShare
    },
    INIT_SETTING_PARAMS: function(state, params){
        state.params = params
    },
    CHANGE_SETTING_DATA: function(state, {type, value}){
        switch(type){
            case 'roomTitle' :
                state.params.roomTitle = value;
                break;
            case 'definePasswd' :
                state.params.definePasswd = value;
                break;
            case 'passwd' :
                state.params.passwd = value;
                break;
            case 'defaultRoleCamera' :
                state.params.defaultRoleCamera = value;
                break;
            case 'defaultRoleMic' :
                state.params.defaultRoleMic = value;
                break;
            case 'defaultRoleReset' :
                state.params.defaultRoleReset = value;
                break;
            case 'defaultRoleId' :
                state.params.defaultRoleId = value;
                break;
            case 'defaultDeviceType' :
                state.params.defaultDeviceType = value;
                break;
            case 'useChat' :
                state.params.useChat = value;
                break;
            case 'useWaitingMode' :
                state.params.useWaitingMode = value;
                break;
            case 'isDeviceRequired' :
                state.params.isDeviceRequired = value;
                break;
            case 'videoQuality' :
                state.params.videoQuality = value;
                break;
            case 'useQnA' :
                state.params.useQnA = value;
                break;
            case 'useQnAShare' :
                state.params.useQnAShare = value;
                break;
            case 'webinarType' :
                state.params.webinarType = value || 'none';
                break;
            case 'videoLayout' :
                state.params.videoLayout = value || this.getters['call/currentVideoLayout'];
                break;
            case 'live' :
                state.params.live = value;
                break;
            case 'useDocMargin' :
                state.params.useDocMargin = value;
                break;
            case 'wallModeTargetScreen' :
                state.params.wallModeTargetScreen = value;
                break;
        }
    }
}